import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface OnlineIndicatorProps {
  lastOnlineAt?: string | null;
  className?: string;
  thresholdMinutes?: number;
}

const OnlineIndicator = ({ lastOnlineAt, className = "", thresholdMinutes = 5 }: OnlineIndicatorProps) => {
  if (!lastOnlineAt) return null;
  const date = new Date(lastOnlineAt);
  const isOnline = Date.now() - date.getTime() < thresholdMinutes * 60 * 1000;
  const label = isOnline
    ? "Online"
    : `Visto em ${format(date, "dd/MM HH:mm", { locale: ptBR })}`;
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <span
        className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${
          isOnline ? "bg-green-500" : "bg-red-500"
        }`}
      />
      <span className="text-[8px] text-muted-foreground truncate">{label}</span>
    </div>
  );
};

export default OnlineIndicator;
